import { render, staticRenderFns } from "./OrderDone.vue?vue&type=template&id=7671351a&scoped=true&"
import script from "./OrderDone.vue?vue&type=script&lang=js&"
export * from "./OrderDone.vue?vue&type=script&lang=js&"
import style0 from "./OrderDone.vue?vue&type=style&index=0&id=7671351a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7671351a",
  null
  
)

export default component.exports